import { registerRepeatable } from '@/services/repeatable';
import useAxios from '@/hooks/useAxios';
import { Cache } from '@/services/cache';
import { RepeatableData } from '@/store/modules/repeatable/types';

registerRepeatable('json_feed', async (model) => {
  const cacheKey = `json-feed-${model.state.feedUrl}`;

  // eslint-disable-next-line security/detect-non-literal-fs-filename
  if (Cache.exists(cacheKey)) {
    return Cache.get<RepeatableData[]>(cacheKey) ?? [];
  }

  if (!model.state.feedUrl) {
    Cache.set<RepeatableData[]>(cacheKey, []);
    return [];
  }

  const { fetchData } = useAxios<Record<string, unknown>[]>(model.state.feedUrl);
  const data = await fetchData();

  const formattedData = data.map<RepeatableData>((item, index) => {
    return {
      id: index,
      ...item
    };
  });

  Cache.set(cacheKey, formattedData);

  return formattedData;
});
